import Page from "components/Page";
import React, { useEffect, useState } from "react";
import Loading from "wrappers/Loading";
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { Accordion, Card, Button } from "react-bootstrap";
import "./styles.scss";
import { useForm } from "react-hook-form";
import { FAQS } from "containers/Faqs/constants";


const Faqspage = ({ qParams }) => {
  const methods = useForm({ mode: "onChange" });
  const [loading, setLoading] = useState(false);
  const [selectedAccordionIcons, setAccordionIcons] = useState(null);
  const [preguntasArray, setPreguntasArray] = useState([]);


  const getData = async () => {
    setLoading(true);
    const data = await ApiKeyFetch.instance().post(FAQS.endpoints.faqs, {});
    if (data.transaccion === true) {
      setPreguntasArray(data?.faqs);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);


  return (
    <Loading loading={loading}>
      <Page>
        <div className='container my-4'>
          <div className='border mx-1 '>
            <div className='row px-5'>
              <div className='col-md-12 mt-5'>
                <h1 className='text-center text-mex'>Preguntas Frecuentes</h1>
              </div>
            </div>
            <div className='px-5'>
              <Accordion defaultActiveKey='0' flush>
                {preguntasArray?.map((item) => {
                  return (
                    <div>
                      {htmlMessage(item?.titulo)}
                      {item?.preguntas?.map((preg, index) => {
                        const eventKey = item?.titulo + index;// Icono actual basado en el estado
                        const iconClass = selectedAccordionIcons===eventKey
                          ? "pi pi-minus" // Icono para el estado abierto (evento toggle activo)
                          : "pi pi-plus"; // Icono para el estado cerrado (evento toggle inactivo)
                        return (
                          <Card>
                            {htmlMessage(preg?.producto)}
                            <Card.Header>
                              <Accordion.Toggle
                                as={Button}
                                variant='link'
                                eventKey={eventKey}
                                className='font-header-card-accordion btn-accordion-personalizado'
                                onClick={() => {
                                  // Actualizar el estado del icono al hacer clic en el evento toggle
                                  setAccordionIcons(eventKey);
                                }}>
                                <div className='row'>
                                  <div className='col-12 col-sm-11'>
                                    {htmlMessage(preg?.pregunta)}
                                  </div>
                                  <div className='col-12 col-sm-1 text-center'>
                                    <i className={`pi ${iconClass}`}></i>
                                  </div>
                                </div>
                              </Accordion.Toggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey={item?.titulo + index}>
                              <Card.Body>{htmlMessage(preg?.respuesta)}</Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        );
                      })}
                      <br></br>
                    </div>
                  );
                })}
              </Accordion>
            </div>
            <br></br>
          </div>
        </div>
      </Page>
    </Loading>
  );
};
export default Faqspage;

const htmlMessage = (mssg) => {
  return (
    <div
      style={{}}
      dangerouslySetInnerHTML={{
        __html: mssg,
      }}
    />
  );
};
